import * as React from 'react';
import { Paper } from '@mui/material';

interface volumeSliderProps {
  soundVolume: number,
  setSoundVolume: Function
}

function VolumeSlider(props: volumeSliderProps) {
  
  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    props.setSoundVolume(newVolume);
  };
    
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <Paper>
        <label htmlFor="volume">Volume: {Math.round(props.soundVolume * 100)}%</label>
        <input
          id="volume"
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={props.soundVolume}
          onChange={handleVolumeChange}
        />
      </Paper>
    </div>
  );
}

export default VolumeSlider;
